module.exports = __webpack_public_path__ + "img/open33.3800a465.png";